import type { ReactNode } from 'react';

import { NavLink } from '@components/NavLink/NavLink';

import * as PATHS from './paths';

interface ErrorMessages {
  [k: string]: ReactNode;
}

export const FirebaseErrors = (): ErrorMessages => {
  const errorMessages: ErrorMessages = {
    'auth/invalid-credential': (
      <>
        You have entered an invalid email or password. Try again or&nbsp;<NavLink to={PATHS.REGISTER}>create a new account</NavLink>.
      </>
    ),
    'auth/weak-password': <>Password should be at least 6 characters.</>,
    'auth/user-not-found': (
      <>
        You have entered an invalid email or password. Try again or&nbsp;<NavLink to={PATHS.REGISTER}>create a new account</NavLink>.
      </>
    ),
    'auth/wrong-password': (
      <>
        You have entered an invalid email or password. Try again or&nbsp;<NavLink to={PATHS.REGISTER}>create a new account</NavLink>.
      </>
    ),
    'auth/popup-closed-by-user': <>Login popup was closed. Please try again.</>,
    'auth/provider-already-linked': <>This account is already linked.</>,
    'auth/requires-recent-login': (
      <>
        This action requires a recent login. Please log out and in again. <NavLink to={PATHS.LOGOUT}>Log out</NavLink>
      </>
    ),
    'auth/invalid-action-code': <>The action code is not valid or no longer valid.</>,
  };

  return errorMessages;
};
